<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <pages-dropdown
        class="d-none d-lg-block"
      />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <locale />
      <feather-icon
        class="d-none d-lg-block cursor-pointer nav-icon"
        size="21"
        icon="HelpCircleIcon"
        :title="$t('help.help')"
        @click="$router.push({name:'owner:help'})"
      />
      <notification-dropdown />
      <profile-actions-dropdown />

    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BNavbarNav, BLink, VBToggle, VBModal,
} from 'bootstrap-vue'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'

import ProfileActionsDropdown from '@/@bya3/components/navbar/ProfileActionsDropdown'
import PagesDropdown from '../../@bya3/components/navbar/PagesDropdown'

export default {
  components: {
    NotificationDropdown: () => import('../../@bya3/components/navbar/NotificationDropdown'),
    ProfileActionsDropdown,
    PagesDropdown,
    BLink,
    Locale,
    BNavbarNav,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => null,
    },
  },
}
</script>
